<template>
    <div
        class="flex-row-fluid d-flex flex-center justfiy-content-xl-first"
        id="contenedorLicitaciones"
    >
        <div class="shadow-sm p-lg-16" style="width: 100%">
            <div class="text-center mb-5">
                <h1
                    class="text-blue mb-13"
                    style="font-size: 1.9rem !important"
                >
                    Licitaciones
                </h1>
                <div class="container" id="licitaciones-list">
                    <div>
                        <Carousel
                            :autoplay="100000"
                            :wrap-around="true"
                            :settings="settings"
                            :breakpoints="breakpoints"
                            :key="key"
                        >
                            <Slide
                                class="carrusel-licitaciones"
                                v-for="(item, index) in items"
                                :key="index"
                            >
                                <div class="card w-100" style="">
                                    <div
                                        class="card-head px-5 d-flex justify-content-between"
                                    >
                                        <h6
                                            class="card-title m-0 pt-6 text-uppercase"
                                        >
                                            {{ item.nombre }}
                                        </h6>
                                    </div>
                                    <div class="card-body">
                                        <div class="datosLicitacion row">
                                            <div class="parametro parametroUbi">
                                                Ubicación:
                                            </div>
                                            <div
                                                class="dato parametroUbi mb-3 mt-2"
                                            >
                                                {{ item.ubicacion }}
                                            </div>

                                            <div
                                                class="parametro parametroFecha col col-5"
                                            >
                                                Fecha publicación :
                                            </div>
                                            <div
                                                class="dato parametroFecha col col-7 mb-2"
                                            >
                                                {{ item.fechaPublicacion }}
                                            </div>

                                            <div class="parametro col col-5">
                                                Fecha termino :
                                            </div>
                                            <div
                                                class="dato col col-7 fecha-termino"
                                            >
                                                {{ item.fechaTermino }}
                                                <span class="ms-2">
                                                    <strong>Hasta </strong> las
                                                    {{ item.horaTermino }}</span
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="container container-participar"
                                        >
                                            <button
                                                class="btn btn-melon"
                                                @click="
                                                    cargarModel(item.codigo)
                                                "
                                            >
                                                Participar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Slide>

                            <template #addons>
                                <Navigation />
                                <Pagination />
                            </template>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Licitar
        v-if="nuevoLiicitante"
        @cancelar="nuevoLiicitante = false"
        @guardarLicitante="guardarLicitante"
        :idLicitacion="idLicitacion"
    ></Licitar>

    <!--Modal Error-->
    <transition name="fade">
        <div class="modal-overlay" v-if="showModalError">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p
                            class="modal-title header-error"
                            id="exampleModalLabel"
                        >
                            ERROR
                        </p>
                        <button
                            type="button"
                            class="closeModel"
                            data-dismiss="modal"
                            aria-label="Cerrar"
                            @click="showModalError = false"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                            >
                                <circle cx="15" cy="15" r="15" fill="#006C90" />
                                <path
                                    d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{ mensajeError }}</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-error"
                            @click="showModalError = false"
                        >
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <!--Modal Exito-->
    <transition name="fade">
        <div class="modal-overlay" v-if="showModalExito">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title" id="exampleModalLabel">
                            Felicitaciones!!!
                        </p>
                        <button
                            type="button"
                            class="closeModel"
                            data-dismiss="modal"
                            aria-label="Cerrar"
                            @click="showModalExito = false"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                            >
                                <circle cx="15" cy="15" r="15" fill="#006C90" />
                                <path
                                    d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{ mensajeExito }}</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-guardar"
                            @click="showModalExito = false"
                        >
                            Aceptar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { Actions } from "@/store/enums/StoreEnums";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { ref } from "vue";
import { useStore } from "vuex";
import Licitar from "@/components/licitaciones/Licitar.vue";

export default {
    name: "Licitaciones",
    emits: ["idLicitacion","mostrarLicitaciones"],
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
        Licitar,
    },
    setup(props, { emit }) {
        const items = ref([]);
        const store = useStore();
        const key = ref(0)
        const mostrar = ref(true)

        const settings = ref({
            itemsToShow: 1,
            snapAlign: "center",
        });
        const breakpoints = ref({
            700: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            1024: {
                itemsToShow: 3,
                snapAlign: "center",
            },
        });

        const fetchItems = async () => {
            try {
                var data = await store.dispatch(Actions.GET_LICITACIONES);
                const documentos = [];
                if (data != null) {
                    data.licitacions.forEach((item) => {
                        var fechaPublicacion = new Date(item.fechaPublicacion);
                        fechaPublicacion =
                            fechaPublicacion.toLocaleDateString("es-ES");

                        var fechaTermino = new Date(item.fechaTermino);
                        var hora =
                            (fechaTermino.getHours() < 10
                                ? "0" + fechaTermino.getHours()
                                : fechaTermino.getHours()) +
                            " : " +
                            (fechaTermino.getMinutes() < 10
                                ? "0" + fechaTermino.getMinutes()
                                : fechaTermino.getMinutes()) +
                            "";
                        fechaTermino = fechaTermino.toLocaleDateString("es-ES");

                        documentos.push({
                            codigo: item.codigo,
                            nombre: item.nombre,
                            ubicacion: item.ubicacion,
                            fechaPublicacion: fechaPublicacion,
                            fechaTermino: fechaTermino,
                            horaTermino: hora.replace(" ", "").replace(" ", ""),
                            siguiente: false,
                            anterior: false,
                            activo: false,
                        });
                    });
                }

                if (documentos.length == 0) {
                   emit("mostrarLicitaciones", false);
                   
                }

                if (documentos.length == 1) {
                    breakpoints.value[700].itemsToShow = 1;
                    breakpoints.value[1024].itemsToShow = 1;
                    key.value += 1;
              
                }

                if (documentos.length == 2) {
                    breakpoints.value[700].itemsToShow = 2;
                    breakpoints.value[1024].itemsToShow = 2;
                    key.value += 1;
                  
                }

                const result = documentos.map((proxy) => ({ ...proxy }));
                items.value = result;

                items.value[items.value.length - 1].anterior = true;
                items.value[1].siguiente = true;
                items.value[0].activo = true;
            } catch (error) {
                console.log(error);
            }
        };

        const enviarId = (id) => {
            emit("idLicitacion", id);
        };

        fetchItems();
        return {
            items,
            enviarId,
            settings,
            breakpoints,
            key,
            mostrar
        };
    },
    data() {
        return {
            store: useStore(),
            nuevoLiicitante: false,
            idLicitacion: "",
            showModalError: false,
            mensajeError: "",
            showModalExito: false,
            mensajeExito: "",
            
        };
    },
    mounted() {
        document.addEventListener("slid.bs.carousel", this.updateActiveIndexes);
    },
    methods: {
        cargarModel(id) {
            this.idLicitacion = id;
            this.nuevoLiicitante = true;
            this.enviarId(id);
        },
        updateActiveIndexes() {
            //this.prevIndex = this.activeIndex;
            const carouselElement = document.getElementById("carouselExample");
            const activeItem = carouselElement.querySelector(
                ".carousel-item.active"
            );
            const pos = Number(activeItem.id);

            let siguiente;
            let anterior;
            for (var i = 0; i < this.items.length; i++) {
                if (i == pos) {
                    this.items[i].activo = true;
                    document.getElementById("" + i).style.maxWidth = "33.3%";
                    document.getElementById("" + i).style.marginRight = "0%";
                    document.getElementById("" + i).style.display = "flex";
                    document.getElementById("" + i).style.justifyContent =
                        "center";
                    if (i == this.items.length - 1) {
                        siguiente = 0;
                        anterior = pos - 1;
                        this.items[pos - 1].anterior = true;
                        this.items[0].siguiente = true;
                    } else if (i == 0) {
                        anterior = this.items.length - 1;
                        siguiente = pos + 1;

                        this.items[this.items.length - 1].anterior = true;
                        this.items[pos + 1].siguiente = true;
                    } else {
                        siguiente = pos + 1;
                        anterior = pos - 1;

                        this.items[pos - 1].anterior = true;
                        this.items[pos + 1].siguiente = true;
                    }
                    document.getElementById("" + anterior).style.maxWidth =
                        "33.3%";
                    document.getElementById("" + anterior).style.marginRight =
                        "0%";
                    document.getElementById("" + anterior).style.display =
                        "flex";
                    document.getElementById(
                        "" + anterior
                    ).style.justifyContent = "center";

                    document.getElementById("" + siguiente).style.maxWidth =
                        "33.3%";
                    document.getElementById("" + siguiente).style.marginRight =
                        "0%";
                    document.getElementById("" + siguiente).style.display =
                        "flex";
                    document.getElementById(
                        "" + siguiente
                    ).style.justifyContent = "center";
                } else if (i != siguiente && i != anterior) {
                    document.getElementById("" + i).style.display = "none";
                    this.items[i].activo = false;
                    this.items[i].anterior = false;
                    this.items[i].siguiente = false;
                }
            }
        },
        async guardarLicitante(files) {
            console.log(files);
            if (files == null) {
                this.mensajeError =
                    "No fue posible crear la solicitud. Intenta nuevamente.";
                this.showModalError = true;
                this.nuevoLiicitante = false;
            } else {
                this.mensajeExito =
                    "La solicitud se creó de manera correcta. \n\r Pronto nos comunicaremos contigo.";
                this.showModalExito = true;
                this.nuevoLiicitante = false;
            }
        },
    },
};
</script>

<style scoped>
.text-blue {
    color: #006c90;
    font-size: 1.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

#contenedorLicitaciones {
    background: rgba(0, 108, 144, 0.1);
}

.card-head {
    /* display: inline-grid;
    justify-items: end; */
    height: 59px;
}

.card-head svg {
    margin-top: 10px;
}

.card .card-body {
    padding: 1.3rem 1.25rem;
    text-align: initial;
}

.card-title {
    text-align: initial;
    color: #006c90;
    font-weight: 700;
    line-height: normal;
    color: #006c90;

    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
}

.btn-participar {
    border-radius: 50px;
    background: #006c90;
    width: 180px;
    height: 38px;
    color: #fff !important;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.parametro {
    color: #333;

    font-style: normal;
    font-weight: 700;
    line-height: normal;
    font-size: 14px;
}

.dato {
    color: #333;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.parametroHasta {
    padding: 0px;
    margin-bottom: 1.5rem;
    font-size: 14px;
}

.parametroUbi {
    /* margin-bottom: 1.5rem; */
    /* min-height: 85px; */
    font-size: 14px;
}

.parametroFecha {
    /* margin-bottom: 0.7rem; */
    font-size: 14px;
}

.container-participar {
    align-items: center;
    display: flex;
    justify-content: center;
}

.selector.active {
    background: #006c90;
}

.selector {
    border: 0px;
    background: #fff;
}

.carousel-indicators {
    position: relative !important;
    padding-top: 3%;
    top: 100%;
}

.mostrarIzquierda {
    display: block !important;
}

.mostrarDerecha {
    display: block !important;
}

.active,
.mostrarDerecha,
.mostrarIzquierda {
    max-width: 33.3% !important;
    margin-right: 0% !important;
    display: flex !important;
    justify-content: center;
}

.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-dialog {
    position: fixed !important;
    width: 35rem;
    top: 50px;
}

.modal-header {
    height: 60px;
}

.modal-title {
    color: #006c90;
    font-size: 1.18rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.closeModel {
    border: 0px;
    background-color: #fff;
}

.modal-footer {
    padding: 0px 1.5rem 1.5rem 0px !important;
    border: 0px !important;
}

.btn-guardar {
    display: flex;
    width: 120px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.btn-error {
    color: white;
    background-color: red;
}
</style>
